var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isMobile)?[_c('DesktopBaseLayout',[_c('router-view')],1)]:[_c('MobileBaseLayout',[_c('router-view',{attrs:{"name":"mobile"}})],1)],_c('Scheduler')],2)}
var staticRenderFns = []

export { render, staticRenderFns }